
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.0001 3.41002C21.0001 2.52002 19.9201 2.07002 19.2901 2.70002L12.6901 9.30002L21.0001 17.61V3.41002ZM21.4401 20.88L5.62005 5.06002C5.23005 4.67002 4.60005 4.67002 4.21005 5.06002C3.82005 5.45002 3.82005 6.08002 4.21005 6.47002L9.87005 12.13L2.71005 19.29C2.08005 19.92 2.52005 21 3.41005 21H18.7301L20.0201 22.29C20.4101 22.68 21.0401 22.68 21.4301 22.29C21.8301 21.9 21.8301 21.27 21.4401 20.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-signal-cellular-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSignalCellularOff

    ```js
    <b-new-b-icon-signal-cellular-off />
    ```
</docs>


